import { MultiOpeningMatSummaryThumbnail } from '../../LabOrderDetails/LabOrderDetailsInformation/OrderSummary/MultiOpeningLineItemSummary';
import PhotoModal from '../common/PhotoModal';

const MultiOpeningPhotoModal = ({ isOpen, onClose, lineItem }) => {
  if (!isOpen || !lineItem) return null;

  return (
    <PhotoModal
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="Enlarged multi-opening view"
      transparentContent
    >
      <MultiOpeningMatSummaryThumbnail
        lineItem={lineItem}
        maxWidth={1000}
        maxHeight={700}
      />
    </PhotoModal>
  );
};

export default MultiOpeningPhotoModal;
